import styled, { keyframes } from 'styled-components';

interface ModalFooterProps {
  isDisable: boolean;
}

export const InformativeSpan = styled.span`
  color: #9e9e9e;
  font-size: 13px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: -5px;
`;

export const LittleButton = styled.button`
  background: transparent;
  border: 0;

  span {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #0d47a1;
    font-size: 14px;
    border: 0;

    &:after {
      content: '';

      position: absolute;
      bottom: -5px;
      left: 1px;

      height: 1px;
      width: 0;

      background: #0d47a1;
      transition: width 0.35s ease-in-out;
    }

    &:hover::after {
      width: 100%;
    }
  }

  svg {
    margin-right: 5px;
  }
`;

export const ModalWrapper = styled.div`
  width: 60%;
  max-height: 650px;
  background: #fff;
  border-radius: 6px;
  padding: 15px 20px;

  div.header {
  }

  div.description {
    margin-bottom: 10px;
    color: #616161;
    line-height: 1.6;
  }
`;

export const ModalHeader = styled.div`
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 5px;

    > h1 {
      font-size: 22px;
      color: #424242;
    }

    > button {
      position: relative;
      background: transparent;
      border: none;
      color: #d32f2f;
      padding: 5px;
      border-radius: 15px;
      transition: all 0.35s ease-in-out;

      &:hover {
        color: #b71c1c;
        transform: scale(1.125);
      }
    }
  }

  div.description {
    margin-bottom: 20px;
    color: #616161;
    line-height: 1.6;
  }
`;

export const ModalFooter = styled.div<ModalFooterProps>`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    width: 200px;

    padding: 10px 0;
    border: none;
    border-radius: 8px;

    font-size: 15px;
    font-weight: 500;
    background: #1976d2;
    color: #fff;

    transition: all 0.35s ease-in;

    &:hover {
      background: #1565c0;
    }

    &:disabled {
      border: 1px solid #757575;
      color: #757575;
      background: #f5f5f5 !important;
      cursor: not-allowed;
    }
  }
`;

export const ItemsToOrder = styled.div`
  width: 100%;
  height: 400px;

  div.header {
    display: flex;
    align-items: center;

    background: #eee;

    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    div.title_section {
      padding: 10px 0;
      width: 25%;
      text-align: center;

      h3 {
        color: #424242;
        font-size: 15px;
      }

      & + div {
        border-left: 1px solid #e0e0e0;
      }
    }
  }

  div.content {
    display: flex;
    align-items: center;

    width: 100%;
    height: 350px;

    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #e0e0e0;
  }
`;

export const OrderList = styled.div`
  width: 25%;
  max-height: 350px;
  height: 100%;
  overflow-y: scroll;

  .item_order:hover {
    color: #424242 !important;
    background: #fafafa !important;
  }

  button {
    display: flex;
    align-items: center;
    width: 100%;

    background: transparent;
    border: none;
    border-bottom: 1px solid #e0e0e0;

    padding: 12px 15px;
    color: #757575;

    cursor: grab;
    transition: all 0.35s ease-in-out;

    svg {
      margin-right: 25px;
    }

    span {
      font-size: 15px;
      font-weight: 400;
    }

    &:hover {
      color: #424242;
      background: #fafafa;
    }
  }

  & + div {
    border-left: 1px solid #e0e0e0;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.25);
  }
`;

const loadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const ActivityIndicator = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;

  &:after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: ${loadingAnimation} 1.2s linear infinite;
  }
`;
